import Axios from 'axios'
import { OAUTH_API } from '@/services/Configuration'
import { getAddresses } from '@/services/FramedCheckout/addressServices/getAddresses'

import { standardizeAddressParky } from '@/services/Standardizers'

const saveAddressToUser = async ({ address, email }) => {
  try {
    const { data } = await Axios.post(`${OAUTH_API}/sf/customer/address/`, standardizeAddressParky(address))
    const newAddressId = data?.data?.[0]?.id || ''
    const addresses = await getAddresses({ email })
    return { success: true, savedAddresses: addresses, newAddressId }
  } catch (e) {
    return { success: false }
  }
}

export default saveAddressToUser
